import { setTerm } from './helpers';

export const setAllWeekAccess = setTerm('all_week_access');
